const Hero = () => {
  return (
    <>
      <div className="relative h-[80vh] md:h-[90vh] flex justify-center items-center overflow-hidden pt-[70px]">

        {/* Dotted rotating circles - Reduced size for mobile */}
        <div className="absolute w-[180px] h-[180px] md:w-[600px] md:h-[600px] lg:w-[900px] lg:h-[900px] border-[1px] md:border-2 border-dashed border-gray-300/30 md:border-gray-300/50 rounded-full animate-[spin_40s_linear_infinite]" />
        <div className="absolute w-[120px] h-[120px] md:w-[400px] md:h-[400px] lg:w-[600px] lg:h-[600px] border-[1px] md:border-2 border-dashed border-gray-300/20 md:border-gray-300/50 rounded-full animate-[spin_40s_linear_infinite_reverse]" />

        {/* LEFT CIRCLES - Hidden on small screens, shown on medium+ */}
        <div className="hidden md:block absolute left-[5%] lg:left-[12%] top-[50%] translate-y-[-50%] w-[100px] h-[100px] lg:w-[140px] lg:h-[140px] rounded-full shadow-lg bg-[conic-gradient(from_270deg,#00B7B3_0deg_180deg,#a2f7fa_180deg_360deg)] flex flex-col items-center justify-center animate-[float_6s_ease-in-out_infinite]">
          <img
            src="/assets/Yourcause.webp"
            className="w-[80px] h-[80px] lg:w-[115px] lg:h-[115px] rounded-full bg-white p-1 object-cover"
            alt="Your cause"
          />
          <span className="absolute bottom-[-25px] left-1/2 transform -translate-x-1/2 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-[10px] lg:text-[12px] font-bold text-gray-700 shadow-sm">
            Your cause
          </span>
        </div>

        <div className="hidden md:block absolute left-[10%] lg:left-[22%] top-[10%] w-[100px] h-[100px] lg:w-[140px] lg:h-[140px] rounded-full shadow-lg bg-[conic-gradient(from_270deg,#00B7B3_0deg_180deg,#a2f7fa_180deg_360deg)] flex items-center justify-center animate-[float_7s_ease-in-out_infinite_1s]">
          <img
            src="/assets/medical.webp"
            className="w-[80px] h-[80px] lg:w-[115px] lg:h-[115px] rounded-full bg-white p-1 object-cover"
            alt="Medical"
          />
          <span className="absolute bottom-[-25px] left-1/2 transform -translate-x-1/2 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-[10px] lg:text-[12px] font-bold text-gray-700 shadow-sm">
            Medical
          </span>
        </div>

        <div className="hidden md:block absolute left-[10%] lg:left-[22%] top-[80%] w-[100px] h-[100px] lg:w-[140px] lg:h-[140px] rounded-full shadow-lg bg-[conic-gradient(from_270deg,#00B7B3_0deg_180deg,#a2f7fa_180deg_360deg)] flex items-center justify-center animate-[float_8s_ease-in-out_infinite_2s]">
          <img
            src="/assets/emrgency.jpeg"
            className="w-[80px] h-[80px] lg:w-[115px] lg:h-[115px] rounded-full bg-white p-1 object-cover"
            alt="Emergency"
          />
          <span className="absolute bottom-[-25px] left-1/2 transform -translate-x-1/2 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-[10px] lg:text-[12px] font-bold text-gray-700 shadow-sm">
            Emergency
          </span>
        </div>

        {/* CENTER CONTENT - Modified for mobile */}
        <div className="z-10 text-center px-4 max-w-4xl mx-auto">
          <div className="md:hidden absolute top-[12%] left-1/2 transform -translate-x-1/2 z-20">
            <p className="text-[11px] font-medium text-gray-900 animate-[fadeInUp_0.8s_ease]">
              #1 crowdfunding platform
            </p>
          </div>

          {/* Mobile: Centered content between images */}
          <div className="md:hidden absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 text-center">
            <h1 className="text-[20px] font-bold leading-tight text-gray-900 mb-3 animate-[fadeInUp_1s_ease_0.2s]">
              Successful fundraisers start here
            </h1>
            
            <div className="animate-[fadeInUp_1.2s_ease_0.4s]">
              <button className="px-5 py-2 bg-[#00B7B3] text-white rounded-full text-[14px] font-bold cursor-pointer hover:scale-105 hover:shadow-xl transition-all duration-300 active:scale-95 shadow-lg hover:bg-[#00A19D]">
                Start a fundraiser
              </button>
            </div>
          </div>

          {/* Desktop: Original content */}
          <div className="hidden md:block">
            <p className="text-[14px] md:text-[16px] font-medium mb-4 text-gray-900 animate-[fadeInUp_0.8s_ease]">
              #1 crowdfunding platform
            </p>

            <h1 className="text-[36px] md:text-[48px] lg:text-[56px] font-extrabold leading-tight text-gray-900 animate-[fadeInUp_1s_ease_0.2s]">
              Successful fundraisers start here
            </h1>

            <div className="mt-8 animate-[fadeInUp_1.2s_ease_0.4s]">
              <button className="px-6 py-3 md:px-8 md:py-3 bg-[#00B7B3] text-white rounded-full text-[16px] md:text-[18px] font-bold cursor-pointer hover:scale-105 hover:shadow-xl transition-all duration-300 active:scale-95 shadow-lg hover:bg-[#00A19D]">
                Start a fundraiser
              </button>
            </div>
          </div>
        </div>

        {/* RIGHT CIRCLES - Hidden on small screens, shown on medium+ */}
        <div className="hidden md:block absolute right-[10%] lg:right-[22%] top-[10%] w-[100px] h-[100px] lg:w-[140px] lg:h-[140px] rounded-full shadow-lg bg-[conic-gradient(from_270deg,#00B7B3_0deg_180deg,#a2f7fa_180deg_360deg)] flex items-center justify-center animate-[float_7s_ease-in-out_infinite_1.5s]">
          <img
            src="/assets/business.jpeg"
            className="w-[80px] h-[80px] lg:w-[115px] lg:h-[115px] rounded-full bg-white p-1 object-cover"
            alt="Business"
          />
          <span className="absolute bottom-[-25px] left-1/2 transform -translate-x-1/2 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-[10px] lg:text-[12px] font-bold text-gray-700 shadow-sm">
            Business
          </span>
        </div>

        <div className="hidden md:block absolute right-[5%] lg:right-[12%] top-[50%] translate-y-[-50%] w-[100px] h-[100px] lg:w-[140px] lg:h-[140px] rounded-full shadow-lg bg-[conic-gradient(from_270deg,#00B7B3_0deg_180deg,#a2f7fa_180deg_360deg)] flex items-center justify-center animate-[float_6s_ease-in-out_infinite_0.5s]">
          <img
            src="/assets/animal.jpeg"
            className="w-[80px] h-[80px] lg:w-[115px] lg:h-[115px] rounded-full bg-white p-1 object-cover"
            alt="Animal"
          />
          <span className="absolute bottom-[-25px] left-1/2 transform -translate-x-1/2 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-[10px] lg:text-[12px] font-bold text-gray-700 shadow-sm">
            Animal
          </span>
        </div>

        <div className="hidden md:block absolute right-[10%] lg:right-[22%] top-[80%] w-[100px] h-[100px] lg:w-[140px] lg:h-[140px] rounded-full shadow-lg bg-[conic-gradient(from_270deg,#00B7B3_0deg_180deg,#a2f7fa_180deg_360deg)] flex items-center justify-center animate-[float_8s_ease-in-out_infinite_2.5s]">
          <img
            src="/assets/education.jpeg"
            className="w-[80px] h-[80px] lg:w-[115px] lg:h-[115px] rounded-full bg-white p-1 object-cover"
            alt="Education"
          />
          <span className="absolute bottom-[-25px] left-1/2 transform -translate-x-1/2 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-[10px] lg:text-[12px] font-bold text-gray-700 shadow-sm">
            Education
          </span>
        </div>

        {/* Mobile circles - Arranged in a square around centered text */}
        <div className="md:hidden absolute top-[22%] left-[12%] w-[65px] h-[65px] rounded-full shadow-lg bg-[conic-gradient(from_270deg,#00B7B3_0deg_180deg,#a2f7fa_180deg_360deg)] flex items-center justify-center animate-pulse">
          <img
            src="/assets/medical.webp"
            className="w-[50px] h-[50px] rounded-full bg-white p-1 object-cover"
            alt="Medical"
          />
        </div>

        <div className="md:hidden absolute top-[22%] right-[12%] w-[65px] h-[65px] rounded-full shadow-lg bg-[conic-gradient(from_270deg,#00B7B3_0deg_180deg,#a2f7fa_180deg_360deg)] flex items-center justify-center animate-pulse delay-150">
          <img
            src="/assets/business.jpeg"
            className="w-[50px] h-[50px] rounded-full bg-white p-1 object-cover"
            alt="Business"
          />
        </div>

        <div className="md:hidden absolute bottom-[28%] left-[12%] w-[65px] h-[65px] rounded-full shadow-lg bg-[conic-gradient(from_270deg,#00B7B3_0deg_180deg,#a2f7fa_180deg_360deg)] flex items-center justify-center animate-pulse delay-300">
          <img
            src="/assets/emrgency.jpeg"
            className="w-[50px] h-[50px] rounded-full bg-white p-1 object-cover"
            alt="Emergency"
          />
        </div>

        <div className="md:hidden absolute bottom-[28%] right-[12%] w-[65px] h-[65px] rounded-full shadow-lg bg-[conic-gradient(from_270deg,#00B7B3_0deg_180deg,#a2f7fa_180deg_360deg)] flex items-center justify-center animate-pulse delay-450">
          <img
            src="/assets/education.jpeg"
            className="w-[50px] h-[50px] rounded-full bg-white p-1 object-cover"
            alt="Education"
          />
        </div>

        {/* Animated background elements - Reduced for mobile */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-1 h-1 md:w-2 md:h-2 bg-teal-400/20 md:bg-teal-400/30 rounded-full animate-ping"></div>
          <div className="absolute top-1/3 right-1/4 w-1.5 h-1.5 md:w-3 md:h-3 bg-teal-300/15 md:bg-teal-300/20 rounded-full animate-ping delay-300"></div>
          <div className="absolute bottom-1/4 left-1/3 w-1 h-1 md:w-2 md:h-2 bg-teal-400/20 md:bg-teal-400/30 rounded-full animate-ping delay-700"></div>
          <div className="absolute bottom-1/3 right-1/3 w-1.5 h-1.5 md:w-3 md:h-3 bg-teal-300/15 md:bg-teal-300/20 rounded-full animate-ping delay-1000"></div>
        </div>

        {/* Scroll indicator - Smaller on mobile */}
        <div className="absolute bottom-6 md:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-5 h-8 md:w-6 md:h-10 border-2 border-gray-300 md:border-gray-400 rounded-full flex justify-center">
            <div className="w-1 h-2 md:h-3 bg-gray-300 md:bg-gray-400 rounded-full mt-1 md:mt-2"></div>
          </div>
        </div>

      </div>

      {/* ==================== Statistics Section ==================== */}
      <section className="bg-[#fff3d0] border-y border-gray-200 px-4 md:px-8 py-6 overflow-hidden">
        <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row items-center justify-center gap-4 md:gap-10 animate-[slideInUp_1s_ease]">
          
          <div className="flex items-center gap-3 text-[14px] md:text-[18px] text-gray-800 whitespace-nowrap">
            <i className="fa-solid fa-bolt text-[16px] md:text-[22px] text-gray-900 animate-pulse"></i>
            <p>No fee to start fundraising</p>
          </div>

          <span className="hidden md:block w-[120px] border-t-2 border-dotted border-gray-500"></span>
          <div className="md:hidden w-8 h-px bg-gray-400"></div>

          <div className="flex items-center gap-3 text-[14px] md:text-[18px] text-gray-800 whitespace-nowrap">
            <i className="fa-regular fa-clock text-[16px] md:text-[22px] text-gray-900 animate-spin-slow"></i>
            <p>1 donation made every second</p>
          </div>

          <span className="hidden md:block w-[120px] border-t-2 border-dotted border-gray-500"></span>
          <div className="md:hidden w-8 h-px bg-gray-400"></div>

          <div className="flex items-center gap-3 text-[14px] md:text-[18px] text-gray-800 whitespace-nowrap">
            <i className="fa-regular fa-clipboard text-[16px] md:text-[22px] text-gray-900 animate-bounce"></i>
            <p>
              <strong>100+</strong> fundraisers started daily
            </p>
          </div>

        </div>
      </section>

      {/* Add CSS animations to global or component */}
      <style jsx>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes spin_reverse {
          from {
            transform: rotate(360deg);
          }
          to {
            transform: rotate(0deg);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-15px);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-spin-slow {
          animation: spin 4s linear infinite;
        }

        .animate-float {
          animation: float 6s ease-in-out infinite;
        }

        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease;
        }

        .animate-slideInUp {
          animation: slideInUp 1s ease;
        }

        .animate-\[spin_40s_linear_infinite\] {
          animation: spin 40s linear infinite;
        }

        .animate-\[spin_40s_linear_infinite_reverse\] {
          animation: spin_reverse 40s linear infinite;
        }

        .animate-\[float_6s_ease-in-out_infinite\] {
          animation: float 6s ease-in-out infinite;
        }

        .animate-\[float_7s_ease-in-out_infinite_1s\] {
          animation: float 7s ease-in-out infinite 1s;
        }

        .animate-\[float_8s_ease-in-out_infinite_2s\] {
          animation: float 8s ease-in-out infinite 2s;
        }

        .animate-\[float_7s_ease-in-out_infinite_1\.5s\] {
          animation: float 7s ease-in-out infinite 1.5s;
        }

        .animate-\[float_6s_ease-in-out_infinite_0\.5s\] {
          animation: float 6s ease-in-out infinite 0.5s;
        }

        .animate-\[float_8s_ease-in-out_infinite_2\.5s\] {
          animation: float 8s ease-in-out infinite 2.5s;
        }

        .animate-\[fadeInUp_0\.8s_ease\] {
          animation: fadeInUp 0.8s ease;
        }

        .animate-\[fadeInUp_1s_ease_0\.2s\] {
          animation: fadeInUp 1s ease 0.2s;
        }

        .animate-\[fadeInUp_1\.2s_ease_0\.4s\] {
          animation: fadeInUp 1.2s ease 0.4s;
        }

        .animate-\[slideInUp_1s_ease\] {
          animation: slideInUp 1s ease;
        }
      `}</style>
    </>
  );
};

export default Hero;